import { useState, useCallback, useEffect } from "react";
import { Box } from "@mui/material";
import AppModal from "../components/common/AppModal";
import { NewPolicyModel } from "../components/returnPolicy/newPolicyModel";
import { NewInstructionModel } from "../components/returnPolicy/newInstructionsModel";
import { getPolicy } from "../features/policy/policySlice";
import { getInstruction } from "../features/instructions/instructionSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import LoadingSpinner from "../components/common/Loading";
import PolicySection from "../components/returnPolicy/policySection";
import InstructionSection from "../components/returnPolicy/instructionSection";
import AppSnackbar from "../components/common/AppSnackbar";
import { resetFlags } from '../features/policy/policySlice';  // Adjust the path accordingly
import { resetInstructionFlags } from "../features/instructions/instructionSlice";
import { styles } from "../components/returnPolicy/styles";

export default function ReturnPolicy() {
    const [newPolicyModel, setNewModelPolicy] = useState(false);
    const [newInstructionModel, setNewModelInstruction] = useState(false);
    const [editInstructionID, setEditInstructionID] = useState(0)
    const [editModePolicy, setEditModePolicy] = useState(false);
    const [showAlert, setShowAlert] = useState(false);  // State for showing alert
    const [editModeInstruction, setEditModeInstruction] = useState(false);
    const {
        isPolicyLoading,
        isAddPolicyLoading,
        isUpdatePolicyLoading,
        isDeletePolicyLoading,

        isDeletePolicySuccess,
        isDeletePolicyError,
        isUpdatePolicyError,
        isUpdatePolicySuccess,
        isAddPolicySuccess,
        isAddPolicyError,

        isPolicyError

    }: any = useAppSelector((state) => state.policy);

    const {
        isInstructionLoading,
        isAddInstructionLoading,
        isUpdateInstructionLoading,
        isDeleteInstructionLoading,

        isDeleteInstructionSuccess,
        isDeleteInstructionError,
        isAddInstructionSuccess,
        isAddInstructionError,
        isUpdateInstructionError,
        isUpdateInstructionSuccess,

        isInstructionError

    }: any = useAppSelector((state) => state.instruction);
    const dispatch = useAppDispatch();
    useEffect(() => {
        // Show the alert only once for a successful operation
        if (isDeleteInstructionSuccess ||
            isDeleteInstructionError ||
            isAddInstructionSuccess ||
            isAddInstructionError ||
            isUpdateInstructionError ||
            isUpdateInstructionSuccess ||
            isDeletePolicySuccess ||
            isDeletePolicyError ||
            isUpdatePolicyError ||
            isUpdatePolicySuccess ||
            isAddPolicySuccess ||
            isAddPolicyError
        ) {
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                dispatch(resetFlags());
                dispatch(resetInstructionFlags());
            }, 3500);  // Hide alert after 4 seconds
        }
    }, [isDeletePolicySuccess,
        isDeletePolicyError,
        isUpdatePolicyError,
        isUpdatePolicySuccess,
        isAddPolicySuccess,
        isAddPolicyError, isDeleteInstructionSuccess,
        isDeleteInstructionError,
        isAddInstructionSuccess,
        isAddInstructionError,
        isUpdateInstructionError,
        isUpdateInstructionSuccess, dispatch]);
    const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
    const GetPolicy = useCallback(() => {
        dispatch(getPolicy(pharmacyID))
        dispatch(getInstruction(pharmacyID))
    }, [dispatch]);

    useEffect(() => {
        if (pharmacyID)
            GetPolicy();
    }, [pharmacyID, GetPolicy, isUpdatePolicyLoading, isAddPolicyLoading, isDeletePolicyLoading, isAddInstructionLoading, isUpdateInstructionLoading, isDeleteInstructionLoading]);
    const {
        policyPayload,
    }: any = useAppSelector((state) => state.policy);

    const {
        instructionPayload,
    }: any = useAppSelector((state) => state.instruction);

    const handlePolicyCloseModal = () => {
        setNewModelPolicy(false);
    };

    const handleInstructionCloseModal = () => {
        setNewModelInstruction(false);
    };

    return (
        <Box>
            {/* <Box sx={styles.titleBox}>
                Return Policy / Instructions
            </Box> */}
            {(isPolicyLoading) && <LoadingSpinner fullScreen />}
            <AppModal
                title={"Return Policy"}
                open={newPolicyModel}
                handleClose={handlePolicyCloseModal}
                fullScreen={false}
                maxWidth="sm"
            >
                <NewPolicyModel edit={editModePolicy} editableText={policyPayload?.policy?.policy} setNewModelPolicy={setNewModelPolicy} />
            </AppModal>

            <AppModal
                title="Add Instructions"
                open={newInstructionModel}
                handleClose={handleInstructionCloseModal}
                fullScreen={false}
                maxWidth="sm"
            >
                <NewInstructionModel edit={editModeInstruction} editableText={instructionPayload} editInstructionID={editInstructionID} setNewModelInstruction={setNewModelInstruction} />
            </AppModal>
            <AppSnackbar
                message={isDeletePolicySuccess ? "Policy Deleted Successfully" : isDeletePolicyError && "Unable to Delete Policy"}
                open={showAlert && (isDeletePolicyError || isDeletePolicySuccess)}
                handleClose={() => setShowAlert(false)}
                severity={isDeletePolicySuccess ? "success" : isDeletePolicyError ? "error" : "success"}
            />
            <AppSnackbar
                message={isAddInstructionSuccess ? "Instruction Added Successfully" : isAddInstructionError && "Unable to Add Instruction"}
                open={showAlert && (isAddInstructionSuccess || isAddInstructionError)}
                handleClose={() => setShowAlert(false)}
                severity={isAddInstructionSuccess ? "success" : isAddInstructionError ? "error" : "success"}
            />
            <AppSnackbar
                message={isUpdateInstructionSuccess ? "Instruction Updated Successfully" : isUpdateInstructionError && "Unable to Update Instruction"}
                open={showAlert && (isUpdateInstructionSuccess || isUpdateInstructionSuccess)}
                handleClose={() => setShowAlert(false)}
                severity={isUpdateInstructionSuccess ? "success" : isUpdateInstructionSuccess ? "error" : "success"}
            />

            <AppSnackbar
                message={isDeleteInstructionSuccess ? "Instruction Deleted Successfully" : isDeleteInstructionError && "Unable to Delete Instruction"}
                open={showAlert && (isDeleteInstructionError || isDeleteInstructionSuccess)}
                handleClose={() => setShowAlert(false)}
                severity={isDeleteInstructionSuccess ? "success" : isDeleteInstructionError ? "error" : "success"}
            />
            <AppSnackbar
                message={isAddPolicySuccess ? "Policy Added Successfully" : isAddPolicyError && "Unable to Add Policy"}
                open={showAlert && (isAddPolicySuccess || isAddPolicyError)}
                handleClose={() => setShowAlert(false)}
                severity={isAddPolicySuccess ? "success" : isAddPolicyError ? "error" : "success"}
            />
            <AppSnackbar
                message={isUpdatePolicySuccess ? "Policy Updated Successfully" : isUpdatePolicyError && "Unable to Update Policy"}
                open={showAlert && (isUpdatePolicySuccess || isUpdatePolicySuccess)}
                handleClose={() => setShowAlert(false)}
                severity={isUpdatePolicySuccess ? "success" : isUpdatePolicySuccess ? "error" : "success"}
            />
            <Box sx={styles.containerBox} >
                <Box sx={styles.contentBox}>
                    <PolicySection policy={policyPayload?.policy?.id !== undefined && !isDeletePolicySuccess ? policyPayload?.policy?.policy : ""} setEditModePolicy={setEditModePolicy} setNewModelPolicy={setNewModelPolicy} />
                    <InstructionSection setNewModelInstruction={setNewModelInstruction} instructions={instructionPayload} setEditInstructionID={setEditInstructionID} />
                </Box>
            </Box>
        </Box>
    );
}
